import { CustomFieldValue } from '../../../../../types/custom_field';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

export enum PdfFileProperty {
  page = 'page',
  totalPages = 'totalPages',
  pagination = 'pagination',
}

export interface PdfFileData {
  page: number;
  totalPages: number;
}

export class PdfFileDataResolver extends PdfEntityDataResolver<PdfFileData, PdfFileProperty> {
  properties = Object.values(PdfFileProperty);
  entityType = PdfFieldEntity.pdf;

  getCustomFieldByEntity(entity: PdfFileData, id: string): CustomFieldValue | undefined {
    throw new Error('Pdf file does not support custom fields');
  }

  getLabelByProperty(property: PdfFileProperty): string {
    switch (property) {
      case PdfFileProperty.page:
        return 'Page number';
      case PdfFileProperty.totalPages:
        return 'Total page count';
      case PdfFileProperty.pagination:
        return 'Pagination';
    }
  }

  getValueByProperty(property: PdfFileProperty, entity: PdfFileData): string {
    switch (property) {
      case PdfFileProperty.page:
        return entity.page.toString();
      case PdfFileProperty.totalPages:
        return entity.totalPages.toString();
      case PdfFileProperty.pagination:
        return `Page ${entity.page} of ${entity.totalPages}`;
    }
  }
}
